import { t } from 'i18next';
import { ROUTES } from 'vio-constants';
export function getCurrentUsersViewName(pathname) {
    if (pathname.includes(ROUTES.ROLES)) {
        return t('ROLES');
    }
    if (pathname.includes(ROUTES.USERS)) {
        return t('USER_MANAGEMENT');
    }
    return '';
}
export function isRolesView(pathname) {
    return pathname.includes(ROUTES.ROLES);
}
export function isUsersView(pathname) {
    return pathname.includes(ROUTES.USERS);
}
